// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ClusterStatusObservationInput
 */
export interface ClusterStatusObservationInput {
  /**
   *
   * @type {string}
   * @memberof ClusterStatusObservationInput
   */
  kubernetesVersion?: string;
  /**
   *
   * @type {string}
   * @memberof ClusterStatusObservationInput
   */
  observedAt?: string;
  /**
   *
   * @type {string}
   * @memberof ClusterStatusObservationInput
   */
  oidcIssuerUrl?: string;
}

/**
 * Check if a given object implements the ClusterStatusObservationInput interface.
 */
export function instanceOfClusterStatusObservationInput(
  value: object,
): value is ClusterStatusObservationInput {
  return true;
}

export function ClusterStatusObservationInputFromJSON(
  json: any,
): ClusterStatusObservationInput {
  return ClusterStatusObservationInputFromJSONTyped(json, false);
}

export function ClusterStatusObservationInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ClusterStatusObservationInput {
  if (json == null) {
    return json;
  }
  return {
    kubernetesVersion:
      json['kubernetes_version'] == null
        ? undefined
        : json['kubernetes_version'],
    observedAt: json['observed_at'] == null ? undefined : json['observed_at'],
    oidcIssuerUrl:
      json['oidc_issuer_url'] == null ? undefined : json['oidc_issuer_url'],
  };
}

export function ClusterStatusObservationInputToJSON(
  json: any,
): ClusterStatusObservationInput {
  return ClusterStatusObservationInputToJSONTyped(json, false);
}

export function ClusterStatusObservationInputToJSONTyped(
  value?: ClusterStatusObservationInput | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    kubernetes_version: value['kubernetesVersion'],
    observed_at: value['observedAt'],
    oidc_issuer_url: value['oidcIssuerUrl'],
  };
}
